import { notifyError } from "./notify";

// Backend error_code (HTTP 409); response body { message, error_code, service_uuids }.
export const SERVICE_NO_LONGER_AVAILABLE = "SERVICE_NO_LONGER_AVAILABLE";

function isServiceNoLongerAvailable(error: any): boolean {
  return error?.errorBody?.error_code === SERVICE_NO_LONGER_AVAILABLE;
}

interface ServiceBookingErrorOptions {
  refreshServices?: () => void | Promise<unknown>;
  fallbackMessage?: string;
  title?: string;
}

export function notifyServiceBookingError(
  error: any,
  {
    refreshServices,
    fallbackMessage = "Could not save the appointment. Please try again.",
    title,
  }: ServiceBookingErrorOptions = {},
): void {
  if (isServiceNoLongerAvailable(error)) {
    notifyError(
      "A selected service was removed. Refreshing your services — please rebook.",
      { title: "Service no longer available" },
    );
    void refreshServices?.();
    return;
  }
  notifyError(
    error?.errorBody?.message ?? error?.errorBody?.error ?? fallbackMessage,
    { ...(title ? { title } : {}) },
  );
}
